import { combineReducers } from "redux";
import { data }            from "./data";
import {
  planner,
  lines,
  tasks,
  memos,
  taskables,
  locations,
  schedules,
  orders
} from "./planner";

const reducers = combineReducers({
  data,
  planner,
  lines,
  tasks,
  memos,
  taskables,
  locations,
  schedules,
  orders
});

export default reducers;
